import { cn } from '@/lib/utils';
import { IconType, Icon } from '../Icon';
import { Link, useLocation } from 'react-router-dom';

type Props = {
  href: string;
  text: string;
  svg?: IconType;
  role?: string | null;
  location?: string | null;
  svgRotate?: '90' | '180' | '270' | '-90' | '0';
  textIcon?: IconType;
  testId?: string;
};

const SettingsLink = ({
  href,
  text,
  svg,
  role = null,
  location = null,
  svgRotate = '0',
  textIcon,
  testId,
}: Props) => {
  const { pathname } = useLocation();
  const isActive = pathname === href || window.location.href.includes(href);

  const renderSpanContent = () => {
    switch (true) {
      case !!role:
        return role;
      case !!location:
        return location;
      default:
        return null;
    }
  };

  return (
    <Link
      to={href}
      data-testid={testId}
      className={cn(
        'flex items-center justify-between w-full no-underline text-foreground px-3 py-2 rounded-lg bg-muted/50',
        'hover:text-primary hover:bg-primary/10',
        '[&_svg]:stroke-muted-foreground [&_svg]:-rotate-90',
        'hover:[&_svg]:stroke-primary',
        isActive && 'text-primary bg-primary/10 [&_svg]:stroke-primary',
      )}
    >
      <div className='flex items-center gap-3 [&_svg]:stroke-transparent'>
        <span className='text-sm'>{text}</span>
        {textIcon && <Icon type={textIcon} width='24' height='24' />}
        {renderSpanContent() && <span className='text-sm text-primary'>{renderSpanContent()}</span>}
      </div>

      {svg && <Icon type={svg} width='24' height='24' rotate={svgRotate} />}
    </Link>
  );
};

export { SettingsLink };
